/* eslint-disable */

import MobileNav from "../Partials/MobileNav";
import Load from "../Load";
import MeetingJoinSound from '../../assets/audio/meeting_join.wav';
import React, { Component, Fragment, useState, useEffect } from "react";
import API from "../../Network/API";
import { useNavigate, BrowserRouter as Router, Redirect, Switch, Route, Routes, Link, useParams } from "react-router-dom";
import { toast } from 'react-toastify';

toast.configure();

export default function MeetingRoom() {
    let { room } = useParams();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const location = window.location;
    const searchParams = new URLSearchParams(location.search);
    const toJwt = searchParams.get('toJwt');

    const containerStyle = {
        width: '100%',
        height: '100%',
        background: '#000',
    };

    const playSound = () => {
        try {
            const audio = new Audio(MeetingJoinSound);
            audio.volume = 0.5; // Reduce volume
            
            // Set a timeout to prevent hanging
            const timeoutId = setTimeout(() => {
                audio.pause();
                audio.currentTime = 0;
            }, 3000);
            
            audio.addEventListener('canplaythrough', () => {
                // Clear timeout if audio loads successfully
                clearTimeout(timeoutId);
                
                // Only play if user has interacted with the page
                audio.play().catch(error => {
                    console.log('Audio autoplay prevented:', error);
                    // Don't block the meeting if audio fails
                });
            });
            
            audio.addEventListener('error', () => {
                clearTimeout(timeoutId);
                console.log('Audio failed to load');
                // Don't block the meeting if audio fails
            });
            
        } catch (error) {
            console.log('Audio initialization failed:', error);
            // Don't block the meeting if audio fails
        }
    };


    useEffect(() => {
        if (toJwt) {
            startConference(toJwt, room);
        } else {
            API.get(`/join/` + room).then(response => {
                if (response.data.room !== "") {
                    startConference(response.data.jwt, room);
                }
            if (response.data.error_code === "406") {
                API.get('/meeting/' + room).then(res => {
                    window.location.href = "/meeting/" + room;
                }).catch((e) => {
                    window.location.href = "/meeting-waiting/" + room;
                });

            }
            if (response.data.error_code === '404') {
                toast.error('Invalid meeting id', {
                    position: "bottom-left",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    onClose: () => window.location.href = "/meeting"
                });
            }

        }).catch((err) => {
            toast.error('Invalid meeting', {
                position: "bottom-left",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                onClose: () => window.location.href = "/meeting"
                });
            });
        }
    }, []);

    function startConference(_token, room) {
        try {
            const domain = 'eu-west-21.connectsweb.com';
            const options = {
                roomName: room,
                jwt: _token,
                height: '100%',
                parentNode: document.getElementById('meeting-container'),
            };

            const api = new JitsiMeetExternalAPI(domain, options);

            // Set loading to false immediately when API is created
            setLoading(false);

            api.addEventListener('videoConferenceJoined', () => {
                console.log('Conference joined successfully');
                // Play sound only after successful join and with user interaction
                playSound();
            });

            api.addEventListener('videoConferenceLeft', () => {
                navigate('/meeting');
            });

            api.addEventListener('readyToClose', () => {
                navigate('/meeting');
            });

            // Add error handling for API failures
            api.addEventListener('participantJoined', () => {
                console.log('Participant joined');
            });

            // Fallback: if getCurrentDevices fails, don't block the meeting
            api.getCurrentDevices().then(devices => {
                console.log('Devices loaded successfully');
            }).catch(error => {
                console.log('Device loading failed, but meeting should continue:', error);
            });

            // Set a fallback timeout to ensure loading stops
            setTimeout(() => {
                if (loading) {
                    setLoading(false);
                    console.log('Fallback: stopping loading indicator');
                }
            }, 10000); // 10 second fallback

        } catch (error) {
            console.error('Conference initialization failed:', error);
            setLoading(false);
            toast.error('Failed to initialize meeting', {
                position: "bottom-left",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                onClose: () => window.location.href = "/meeting"
            });
        }
    }

    localStorage.setItem("set_meeting_url", null);
    if (localStorage.getItem("connect_token") === 'undefined' || localStorage.getItem("connect_token") == null) {
        localStorage.setItem("set_meeting_url", window.location.href);
    }
    
    return (
        <Fragment>
            <div className="content-page-box-area">
                <div className="row">
                    <div style={containerStyle}>
                        {loading ? <Load /> : ""}
                        <div id="meeting-container" className="meetingContainerStyle" />
                    </div>
                </div>
            </div>
        </Fragment>
    )
}